module.exports = __webpack_public_path__ + "static/media/file.1d4a21b4.svg";